"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APSelect = require("../../../common/APSelect");
var _APButton = _interopRequireDefault(require("../../../common/APButton"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _FiatDepositFormContainer = _interopRequireDefault(require("../../../Retail/RetailSidePanes/FiatDeposit/FiatDepositFormContainer"));
var _MarginCryptoDepositForm = _interopRequireDefault(require("./MarginCryptoDepositForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('margin-deposit-form');
var MarginDepositFormComponent = /*#__PURE__*/function (_React$Component) {
  function MarginDepositFormComponent() {
    var _this;
    _classCallCheck(this, MarginDepositFormComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MarginDepositFormComponent, [].concat(args));
    _defineProperty(_this, "state", {
      selectedProductId: _this.props.selectedProductId,
      selectedAccountId: _this.props.accountTo
    });
    return _this;
  }
  _inherits(MarginDepositFormComponent, _React$Component);
  return _createClass(MarginDepositFormComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var t = this.props.t;
      var _this$props = this.props,
        products = _this$props.products,
        accounts = _this$props.accounts,
        closeModal = _this$props.closeModal;
      var selectedProduct = products.find(function (product) {
        return product.ProductId === Number(_this2.state.selectedProductId);
      });
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('title')
      }, t('Here you can transfer assets between accounts.')), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('inline-container')
      }, /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
        name: "product",
        label: "".concat(t('Asset'), ":"),
        customClass: bemClasses(),
        options: products.map(function (product) {
          var ProductId = product.ProductId,
            Product = product.Product;
          return {
            value: ProductId,
            label: Product
          };
        }),
        onSelect: function onSelect(value) {
          return _this2.setState({
            selectedProductId: value
          });
        },
        value: this.state.selectedProductId
      }), /*#__PURE__*/_react["default"].createElement(_APSelect.InnerSelect, {
        name: "accountTo",
        label: "".concat(t('To Account'), ":"),
        customClass: bemClasses(),
        options: accounts.map(function (account) {
          var AccountId = account.AccountId,
            AccountName = account.AccountName;
          return {
            value: AccountId,
            label: AccountName
          };
        }),
        onSelect: function onSelect(value) {
          return _this2.setState({
            selectedAccountId: value
          });
        }
      })), selectedProduct ? selectedProduct.ProductType === 'CryptoCurrency' ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('crypto-deposit-container')
      }, /*#__PURE__*/_react["default"].createElement(_MarginCryptoDepositForm["default"], {
        product: selectedProduct
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: bemClasses('confirm-btn-container')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: bemClasses('confirm-btn'),
        type: "button",
        onClick: closeModal
      }, t('OK')))) : /*#__PURE__*/_react["default"].createElement(_FiatDepositFormContainer["default"], {
        product: selectedProduct
      }) : null);
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('margin')(MarginDepositFormComponent);